import { foundationBannerStyles } from '@genesislcap/foundation-ui';
import { neutralLayer1 } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const zeroBannerStyles = css `
  ${foundationBannerStyles}
  .banner {
    background-color: ${neutralLayer1};
  }
`;
